@if (user) {
  <div class="card h-100">
    <div class="card-body">
      <div class="d-flex flex-row">
        <div class="d-flex flex-column me-3">
          <a [routerLink]="'/user/' + user._id">
            <img class="img-100h rounded-sm" [src]="user.image || profilePics.default" alt="">
          </a>
        </div>
        <div class="d-flex flex-column">
          <h5 class="card-title">
            <a [routerLink]="'/user/' + user._id">
              {{user.firstName}} {{user.lastName}} @if (user.disabled) {
              <span class="badge badge-secondary text-uppercase disabled">disabled</span>
            }
          </a>
          @if (auth.currentUser._id === user._id) {
            <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" (click)="goToAccount()"
              >
              <i class="fa fa-pencil"></i> Edit
            </button>
          }
          @if (!user.disabled && isDetailsPage && (auth.isAdmin || canDisableUser)) {
            <button class="btn btn-sm btn-danger py-0 px-1 ms-1" (click)="disableUser(user)"
              >
              <i class="fa fa-ban"></i> Disable user
            </button>
          }
          @if (isDetailsPage) {
            <app-delete-btn-admin (click)="deleteUser(user)"></app-delete-btn-admin>
          }
        </h5>
        <div class="mt-1 d-none d-md-block">
          <i class="fa fa-envelope-o"></i> {{user.email}}
        </div>
        <div class="mt-1">
          <i class="fa fa-tag"></i> {{user.department}}
        </div>
        <div class="mt-1">
          <i class="fa fa-map-marker me-1"></i> {{user.site}}
        </div>
        @if (user.job) {
          <div class="mt-1">
            <i class="fa fa-briefcase"></i> {{user.job}}
            @if (isDetailsPage && (auth.isAdmin || canEditJob)) {
              <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-user-modal" (click)="toggleEditUserModal('job')">
                <i class="fa fa-pencil"></i>
              </button>
            }
          </div>
        }
        @if (!user.job && (auth.isAdmin || canEditJob)) {
          <div class="mt-1">
            <i class="fa fa-briefcase"></i>
            <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-user-modal" (click)="toggleEditUserModal('job')">
              <i class="fa fa-plus-circle"></i> Add position
            </button>
          </div>
        }
      </div>
    </div>
    @if (user.lastLogin && (auth.isAdmin || canLastLogin)) {
      <div class="text-muted small float-end" title="Only some members can see this info">
        last login on {{user.lastLogin | date:'MMM d, h:mm a'}}
      </div>
    }
  </div>
</div>
}

@if (isEditUserModalVisible) {
  <app-edit-user-modal [user]="user" [field]="field"></app-edit-user-modal>
}